import React from 'react';
import OzelliklerCarousel, { CarouselItem } from '../Carousel/OzelliklerCarousel';
import './OzelliklerSection.css';

// Import feature images
import motorImg from '../../assets/img/yenigorsel/IMG-20251204-WA0030.jpg';
import screenImg from '../../assets/img/yenigorsel/IMG-20251204-WA0028.jpg';
import cookidooImg from '../../assets/img/yenigorsel/IMG-20251204-WA0029.jpg';
import babyImg from '../../assets/img/yenigorsel/sm.jpg';
import energyImg from '../../assets/img/yenigorsel/IMG-20251204-WA0031.jpg';

interface OzelliklerSectionProps {
  onOzellikClick?: (ozellikId: string, ozellikName: string) => void;
}

const OzelliklerSection: React.FC<OzelliklerSectionProps> = ({ onOzellikClick }) => {
  const ozellikler: CarouselItem[] = [
    {
      id: 1,
      name: 'Daha Güçlü Motor',
      icon: 'islevsellik.svg',
      title: 'Daha Güçlü Motor',
      description: 'Bugüne kadarki en sessiz Thermomix motoru ile tanışın. Güçten ödün vermeden geliştirilen yeni sürtünmesiz motor teknolojisi, özellikle düşük devirlerde fısıltı sessizliğinde çalışır. Yoğun hamurları yoğururken bile sarsılmaz bir performans sunarak mutfağınızın huzurunu korur.',
      image: motorImg
    },
    {
      id: 2,
      name: 'Gelişmiş Dokunmatik Ekran',
      icon: 'rehberli-pisirme.svg',
      title: 'Gelişmiş Dokunmatik Ekran',
      description: 'Mutfak deneyiminizi devrim niteliğinde değiştiren devasa 10 inçlik kristal netliğinde ekran. Akıllı telefonunuz kadar hızlı ve duyarlı bu panel üzerinden tariflere göz atmak, video izlemek ve tüm pişirme modlarını kontrol etmek artık çok daha keyifli. Fiziksel düğmelere veda edin, tamamen dijital bir şef deneyimine merhaba deyin.',
      image: screenImg
    },
    {
      id: 3,
      name: 'Akıllı Tarif Sistemi (Cookidoo)',
      icon: 'akilli-baglanti.svg',
      title: 'Akıllı Tarif Sistemi (Cookidoo)',
      description: 'Yenilenen Cookidoo® entegrasyonu ile 100.000\'den fazla küresel tarif parmaklarınızın ucunda. Daha büyük ekranda daha sürükleyici bir "Rehberli Pişirme" deneyimi yaşayın. Kişiselleştirilmiş tarif önerileri, haftalık planlama ve otomatik alışveriş listeleriyle mutfaktaki en büyük yardımcınız.',
      image: cookidooImg
    },
    {
      id: 4,
      name: 'Bebekler için En Sağlıklısı',
      icon: 'guvenlik.svg',
      title: 'Bebekler için En Sağlıklısı',
      description: '%45 daha geniş dikdörtgen Varoma haznesi ile bebeğinizin tüm öğünlerini tek seferde hazırlayın. Hassas sıcaklık kontrolü sayesinde vitamin ve mineralleri koruyarak buharda pişirin. Koruyucusuz, katkısız ve tam kıvamında mamalar hazırlamak hiç bu kadar pratik ve sağlıklı olmamıştı.',
      image: babyImg
    },
    {
      id: 5,
      name: 'Enerji Verimliliği & Sessiz Çalışma',
      icon: 'yenilikci-tasarim.svg',
      title: 'Enerji Verimliliği & Sessiz Çalışma',
      description: 'Akıllı ısıtma sistemi, enerjiyi sadece ihtiyaç duyulan yere odaklayarak maksimum verimlilik sağlar. Yeni nesil sessiz motoru ve gelişmiş yalıtımlı gövde tasarımı sayesinde, sabahın erken saatlerinde bile ailenizi uyandırmadan kahvaltınızı hazırlayabilirsiniz.',
      image: energyImg
    },
  ];

  return (
    <section id="ozellikler" className="ozellikler-section">
      <div className="ozellikler-container">
        <div className="ozellikler-header">
          <h2 className="ozellikler-title">
            <span className="highlight">THERMOMİX TM7</span><br />
            HAYATINIZI NEDEN KOLAYLAŞTIRIYOR?
          </h2>
          <div className="ozellikler-description">
            <p>
              <a href="#siparis" className="info-link">Thermomix TM7</a> <strong>28 farklı fonksiyonu</strong> içerisinde
              barındırmaktadır. Bunlar; doğrama, karıştırma, buharda pişirme, yoğurma, soteleme, öğütme, çırpma,
              sous-vide, yavaş pişirme ve daha niceleri..
            </p>
            <p>
              Barındırdığı bu fonksiyonlar ile yenilik, çok yönlülük ve rahatlığı tek bir güçlü cihazda harmanlayarak
              yemek pişirme sanatını yeniden tanımlıyor. Mutfak deneyiminizi zirvelere taşıyan TM7, 20 farklı cihazı
              tek bir şık ünitede sorunsuz bir şekilde birleştirerek size mutfakta benzersiz bir kolaylık ve yaratıcılık sağlıyor.
            </p>
          </div>
        </div>
        <div className="ozellikler-carousel-wrapper">
          <OzelliklerCarousel
            items={ozellikler}
            autoplay={true}
            autoplayDelay={12000}
            pauseOnHover={true}
            loop={true}
          />
        </div>
      </div>
    </section>
  );
};

export default OzelliklerSection;

